import { getProviderOverride } from '@/providers/overrides'
import { humanizeKey } from '@/providers/sourceTypeLabels'

// Names for providers the override table does not carry, so a retained or
// not-yet-catalogued connection never shows its raw key.
const KNOWN_PROVIDER_NAMES = Object.freeze({ youtube: 'YouTube', facebook: 'Facebook', churchstaq: 'ChurchStaq' })

/**
 * A provider's display name for anything that only has the raw key -
 * `ProviderLogo`'s alt text, cards, toasts. The catalog entry's label (when
 * `byKey` is given), else the override table's label, else a known name, else
 * the key humanized (`acme_giving` -> `Acme giving`), never the raw key.
 *
 * @param {string|null|undefined} key
 * @param {Record<string, Object>} [byKey]
 * @returns {string}
 */
export function providerLabel(key, byKey = {}) {
  if (!key) return ''
  const entry = byKey[key]
  return entry?.label || entry?.name || getProviderOverride(key)?.label || KNOWN_PROVIDER_NAMES[key] || humanizeKey(key)
}
